var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "multi-style-edit-container" }, [
    _c("div", { staticClass: "tab-container" }, [
      _c(
        "div",
        { staticClass: "tab-item" },
        [
          _c(_setup.inputSelect, {
            attrs: { value: _setup.tab, items: _setup.tabs },
            on: { input: _setup.onSelectTab },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "tab-item tab-add clickable",
          attrs: { disabled: !_setup.tab },
          on: {
            click: function ($event) {
              return _setup.onRemoveStyleLayer(_setup.tab)
            },
          },
        },
        [
          _c(_setup.SvgIcon, {
            attrs: {
              size: "14",
              type: "mdi",
              path: _setup.path.delete,
              disabled: !_setup.tab,
            },
          }),
        ],
        1
      ),
      !_setup.showAdd
        ? _c(
            "div",
            {
              staticClass: "tab-item tab-add clickable",
              on: {
                click: function ($event) {
                  return _setup.onShowAddStyle(true)
                },
              },
            },
            [
              _c(_setup.SvgIcon, {
                attrs: { size: "14", type: "mdi", path: _setup.path.create },
              }),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "tab-item tab-add clickable",
              on: {
                click: function ($event) {
                  return _setup.onShowAddStyle(false)
                },
              },
            },
            [
              _c(_setup.SvgIcon, {
                attrs: { size: "14", type: "mdi", path: _setup.path.close },
              }),
            ],
            1
          ),
    ]),
    _setup.showAdd
      ? _c("div", { staticClass: "style-container" }, [
          _c(
            "div",
            { staticClass: "add-style-container" },
            [
              _c(
                _setup.baseButton,
                {
                  on: {
                    click: function ($event) {
                      return _setup.onAddStyleLayer("area")
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.trans("map.style-control.add.area")) + " "
                  ),
                ]
              ),
              _c(
                _setup.baseButton,
                {
                  on: {
                    click: function ($event) {
                      return _setup.onAddStyleLayer("line")
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.trans("map.style-control.add.line")) + " "
                  ),
                ]
              ),
              _c(
                _setup.baseButton,
                {
                  on: {
                    click: function ($event) {
                      return _setup.onAddStyleLayer("point")
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.trans("map.style-control.add.point")) + " "
                  ),
                ]
              ),
              _c(
                _setup.baseButton,
                {
                  on: {
                    click: function ($event) {
                      return _setup.onAddStyleLayer("symbol")
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.trans("map.style-control.add.symbol")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _setup.tab
      ? _c(
          "div",
          { staticClass: "style-container" },
          [
            _c(_setup.SingleStyle, {
              attrs: {
                value: _setup.current_layer,
                trans: _vm.trans,
                mapId: _vm.mapId,
              },
              on: {
                "update-style": function ($event) {
                  return _setup.onUpdateStyleLayer($event, _setup.tab)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }